import { CallCard as CallCardComponent } from '../components/call-card';
import { FindFACard as FindFACardComponent } from '../components/find-fa-card';
import { FormCard as FormCardComponent } from '../components/form-card';
import { LogInCard as LogInCardComponent } from '../components/log-in-card';
import { desktop } from '@thrivent/midwest-shared';
import styled from 'styled-components';

// --------------------------------------------------------------------------

export const Section = styled.section`
  display: grid;
  max-width: 78rem;
  margin: 0 auto;
  padding-inline: 1rem;
  grid-gap: 1.5rem;
  padding-bottom: 4rem;
  z-index: 2;
  position: relative;

  ${desktop} {
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: min-content;
  }
`;

export const CallCard = styled(CallCardComponent)`
  ${desktop} {
    grid-column: 1 / 5;
    grid-row: 1;
  }
`;

export const FindFACard = styled(FindFACardComponent)`
  ${desktop} {
    grid-column: 5 / 9;
    grid-row: 1;
  }
`;

export const LogInCard = styled(LogInCardComponent)`
  ${desktop} {
    grid-column: 9 / 13;
    grid-row: 1 / 3;
  }
`;

export const FormCard = styled(FormCardComponent)`
  ${desktop} {
    grid-column: 1 / 9;
    grid-row: 2 / 5;
  }
`;

// --------------------------------------------------------------------------

export const CardSection = () => {
  return (
    <Section>
      <CallCard />
      <FindFACard />
      <LogInCard />
      <FormCard />
    </Section>
  );
};
